import React, { useEffect, useState } from 'react'
import { useDataValue, useDataSubmit, useDataChange } from 'Simple/Data.js'
import { ControlledBoard, moveCard } from '@local/react-kanban'
import View from './view.js'
import Card from './Card'
import EmptyCard from './EmptyCard'
import StageHeader from './StageHeader'
import '@local/react-kanban/dist/styles.css'
import './style.css'

export default function KanbanBoard(props) {
  let stages = useDataValue({
    context: 'board',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let tasks = useDataValue({
    context: 'board_tasks',
    path: 'tasks_tasks',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let changeFilters = useDataChange({
    context: 'filters',
    viewPath: props.viewPath,
  })

  let [board, setBoard] = useState({
    columns: [],
  })

  useEffect(() => {
    setBoard({
      columns: (stages || []).map(({ id, text: title, subscribers }) => ({
        id,
        title,
        is_current_user_subscribed: subscribers?.length > 0,
        cards: (tasks || [])
          .map(({ patients, assignees, ...task }) => ({
            ...task,
            patient: patients[0],
            assignee: assignees[0],
          }))
          .filter(task => task.stage_id === id),
      })),
    })
  }, [stages, tasks])

  let handleCardMove = (card, source, destination) => {
    if (card?.placeholder) return
    let destinationColumn = board.columns.find(
      column => column.id === destination.toColumnId
    )
    if (!destinationColumn) {
      console.error('Destination column not found:', destination.toColumnId)
      return
    }

    let order
    let cards = [...destinationColumn.cards]

    if (source.fromColumnId === destination.toColumnId) {
      cards.splice(source.fromPosition, 1)
    }

    let prevCard = cards[destination.toPosition - 1]
    let nextCard = cards[destination.toPosition]

    if (prevCard && nextCard) {
      order = (prevCard.order + nextCard.order) / 2
    } else if (prevCard) {
      order = prevCard.order + 1000
    } else if (nextCard) {
      order = nextCard.order - 1000
    } else {
      order = Date.now()
    }

    submit({
      type: 'set_task_placement',
      task_id: card.id,
      stage_id: destination.toColumnId,
      order,
    })

    setBoard(currentBoard => moveCard(currentBoard, source, destination))
  }

  let displayBoard = {
    ...board,
    columns: board.columns.map((column, i) => {
      if (column.cards.length === 0) {
        return {
          ...column,
          cards: [
            {
              id: `placeholder-${column.id}`,
              placeholder: true, // this will render the card unable to be dragged
              message:
                i === 0
                  ? `Your tasks will appear here.`
                  : `Move tasks through from start to completion 
with stages.`,
            },
          ],
        }
      }
      return column
    }),
  }

  return (
    <View {...props} onChange={changeFilters}>
      <ControlledBoard
        onCardDragEnd={handleCardMove}
        renderCard={(card, { dragging }) =>
          card.placeholder ? (
            <EmptyCard
              viewPath={`${props.viewPath}/Card(${card.id})`}
              text={card.message}
            />
          ) : (
            <Card
              viewPath={`${props.viewPath}/Card(${card.id})`}
              card={card}
              dragging={dragging}
            />
          )
        }
        renderColumnHeader={column => (
          <StageHeader
            viewPath={`${props.viewPath}/StageHeader(${column.id})`}
            title={column.title}
            count={column.cards.filter(card => !card.placeholder).length}
            stageId={column.id}
            isCurrentUserSubscribed={column.is_current_user_subscribed}
          />
        )}
        allowAddCard={false}
        disableColumnDrag
      >
        {displayBoard}
      </ControlledBoard>
    </View>
  )
}
